import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetSharesForAddToShareMenuQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
  filters?: Types.InputMaybe<Types.ShareFiltersInput>;
}>;


export type GetSharesForAddToShareMenuQuery = { __typename?: 'Query', project?: { __typename?: 'Project', id: string, shares?: { __typename?: 'ShareConnection', totalCount: number, nodes: Array<{ __typename?: 'AdHocAssetsShare', id: string, name: string } | { __typename?: 'CollectionShare', id: string, name: string }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, unfilteredStaticShares?: { __typename?: 'ShareConnection', totalCount: number } | null } | null };


export const GetSharesForAddToShareMenu = /*#__PURE__*/ gql`
    query GetSharesForAddToShareMenu($projectId: ID!, $page: PageInput!, $filters: ShareFiltersInput) {
  project(projectId: $projectId) {
    id
    shares(page: $page, filters: $filters) {
      nodes {
        id
        name
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
    unfilteredStaticShares: shares(
      page: {first: 0}
      filters: {aggregationMode: STATIC}
    ) {
      totalCount
    }
  }
}
    ` as unknown as DocumentNode<GetSharesForAddToShareMenuQuery, GetSharesForAddToShareMenuQueryVariables>;

          

          export const useGetSharesForAddToShareMenuQuery = (options?:QueryHookOptions<GetSharesForAddToShareMenuQuery, GetSharesForAddToShareMenuQueryVariables>) => useQuery(GetSharesForAddToShareMenu, options);

          

          export type GetSharesForAddToShareMenuQueryOptions = QueryHookOptions<GetSharesForAddToShareMenuQuery, GetSharesForAddToShareMenuQueryVariables>;

          

          export const useGetSharesForAddToShareMenuLazyQuery = (options?:LazyQueryHookOptions<GetSharesForAddToShareMenuQuery, GetSharesForAddToShareMenuQueryVariables>) => useLazyQuery(GetSharesForAddToShareMenu, options);

          

          export type GetSharesForAddToShareMenuQueryResult = ReturnType<typeof useGetSharesForAddToShareMenuQuery>;

          
